export const answersCantBeEmpty = 'games.answerRequired'
export const correctAnswerRequired = 'games.correctRequired'
export const queRequired = 'questions.question required'
export const questionsCantBeEmpty = 'questions.question required'
export const linkRequired = 'games.gameLinkRequired'
export const urlValidator = 'errors.validate.link'
export const backgroundMediaRequired = 'questions.backgroundMedia required'

export const questionRules: QuestionRules & {
  defaults: {
    score: number
    time: number
  }
} = {
  defaults: {
    score: 10,
    time: 10,
  },
  trivia: {
    clearBlockTypes: ['survey', 'multiselect'],
    rules: {
      showCorrectAnswer: true,
      maxAnswers: 6,
      showQueScore: true,
      showQueTime: true,
      showXL: true,
    },
    validators: {
      answersCantBeEmpty,
      correctAnswerRequired,
      queRequired,
    },
    fields: [
      'answers',
      'que',
      'openMedia',
      'endMedia',
      'backgroundMedia',
      'src',
    ],
  },
  survey: {
    clearBlockTypes: ['multiselect', 'trivia'],
    rules: {
      maxAnswers: 6,
      showQueScore: true,
      showQueTime: true,
    },
    validators: {
      answersCantBeEmpty,
      queRequired,
    },
    defaults: {
      score: 0,
    },
    fields: [
      'que',
      'answers',
      'openMedia',
      'endMedia',
      'backgroundMedia',
      'src',
    ],
  },
  media: {
    rules: {},
    validators: {
      backgroundMediaRequired,
    },
    fields: ['que', 'openMedia', 'backgroundMedia'],
  },
  ans_images: {
    rules: {
      showCorrectAnswer: true,
      showQueScore: true,
      showQueTime: true,
      maxAnswers: 4,
    },
    validators: {
      answersCantBeEmpty,
      correctAnswerRequired,
      queRequired,
    },
    fields: [
      'que',
      'answers',
      'openMedia',
      'endMedia',
      'backgroundMedia',
      'src',
    ],
  },
  game: {
    rules: {
      showQueScore: true,
    },
    validators: {
      linkRequired,
      urlValidator,
    },
    fields: ['que', 'openMedia', 'endMedia', 'backgroundMedia', 'src', 'link'],
  },
  typing: {
    rules: {
      showQueScore: true,
      showQueTime: true,
      maxAnswers: 1,
    },
    validators: {
      answersCantBeEmpty,
      queRequired,
    },
    fields: [
      'que',
      'answers',
      'openMedia',
      'endMedia',
      'backgroundMedia',
      'src',
    ],
  },
  subject: {
    rules: {},

    validators: {
      queRequired,
    },
    fields: ['que', 'backgroundMedia', 'src'],
  },
  wordsCloud: {
    rules: {
      showQueScore: true,
      showQueTime: true,
    },

    validators: {
      queRequired,
    },
    fields: ['que', 'openMedia', 'endMedia', 'backgroundMedia', 'src'],
  },
  discussion: {
    rules: {},
    validators: {
      queRequired,
    },

    fields: ['que', 'openMedia', 'backgroundMedia', 'src'],
  },
  timeline: {
    rules: {
      showQueScore: true,
      showQueTime: true,
      maxAnswers: 6,
    },
    validators: {
      answersCantBeEmpty,
      queRequired,
    },
    defaults: {
      time: 60,
    },
    fields: [
      'answers',
      'que',
      'questionMessage',
      'openMedia',
      'endMedia',
      'message',
      'backgroundMedia',
      'src',
    ],
  },
  mark: {
    rules: {
      showQueScore: true,
      showQueTime: true,
    },
    validators: {
      queRequired,
      markValidator: {
        dot_x: 'dot_x required',
        dot_y: 'dot_y required',
        radius: 'Radius required',
        markSrcMedia: 'Media is required',
      },
    },
    fields: [
      'que',
      'openMedia',
      'endMedia',
      'dot_x',
      'dot_y',
      'radius',
      'markSrcMedia',
    ],
  },
  math_trivia: {
    rules: {
      maxAnswers: 6,
      showCorrectAnswer: true,
      showQueScore: true,
      showQueTime: true,
      showXL: true,
    },
    validators: {
      answersCantBeEmpty,
      correctAnswerRequired,
      queRequired,
    },
    fields: [
      'que',
      'answers',
      'openMedia',
      'endMedia',
      'backgroundMedia',
      'src',
    ],
  },
  multiselect: {
    clearBlockTypes: ['survey', 'trivia'],
    clearFieldsOnTypeChange: ['additionalText'],
    rules: {
      maxAnswers: 6,
      showCorrectAnswer: true,
      showQueScore: true,
      showQueTime: true,
      showXL: true,
    },
    validators: {
      answersCantBeEmpty,
      correctAnswerRequired,
      queRequired,
    },
    fields: [
      'que',
      'answers',
      'openMedia',
      'endMedia',
      'backgroundMedia',
      'src',
      'additionalText',
    ],
  },
  matchingPairs: {
    rules: {
      maxAnswers: 6,
      showQueScore: true,
      showQueTime: true,
    },
    validators: {
      queRequired,
      answersCantBeEmpty,
      questionsCantBeEmpty,
    },
    fields: ['que', 'openMedia', 'endMedia', 'src', 'questions', 'answers'],
  },
}

export default questionRules
